import { render, staticRenderFns } from "./NotificationSettingsForm.vue?vue&type=template&id=baf416f4&scoped=true"
import script from "./NotificationSettingsForm.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingsForm.vue?vue&type=style&index=0&id=baf416f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf416f4",
  null
  
)

export default component.exports